import { parse, stringify } from 'query-string';
import { globals } from './globals';
function isFindOrSearchPage(deeplink) {
    return deeplink.match(/\/search\/?/);
}
export function rewriteDeeplink(deeplink, whitelistedQueryStringKeysOther = ['useSkyfire', 'skyfireEnv']) {
    const whitelistedQueryStringKeysSearch = [...whitelistedQueryStringKeysOther, 'filter', 'sc'];
    const whitelistedQueryStringKeys = isFindOrSearchPage(deeplink) ? whitelistedQueryStringKeysSearch : whitelistedQueryStringKeysOther;
    // extract query params from deeplink
    // assume query string and hash string can come in any order
    // and that hash string does not contain a ?
    const queryIndex = deeplink.indexOf('?');
    const hashIndex = deeplink.indexOf('#');
    let queryString = '';
    let hashString = '';
    if (queryIndex > -1) {
        queryString = hashIndex < queryIndex
            ? deeplink.slice(queryIndex + 1)
            : deeplink.slice(queryIndex + 1, hashIndex);
    }
    if (hashIndex > -1) {
        hashString = queryIndex < hashIndex
            ? deeplink.slice(hashIndex + 1)
            : deeplink.slice(hashIndex + 1, queryIndex);
    }
    let deeplinkPath = deeplink;
    if (queryIndex > -1 && hashIndex > -1) {
        deeplinkPath = deeplink.slice(0, Math.min(queryIndex, hashIndex));
    }
    else if (queryIndex > -1 || hashIndex > -1) {
        deeplinkPath = deeplink.slice(0, Math.max(queryIndex, hashIndex));
    }
    const deeplinkParams = parse(queryString);
    delete deeplinkParams.skyfireEnv;
    delete deeplinkParams.useSkyfire;
    const currentSearchParams = new URL(globals.location.href).searchParams;
    whitelistedQueryStringKeys.forEach((key) => {
        deeplinkParams[key] = deeplinkParams[key] || currentSearchParams.get(key);
    });
    // generate deeplink's query string
    const deeplinkSearch = stringify(deeplinkParams, { skipNull: true, skipEmptyString: true });
    // build deeplink path with query string
    return deeplinkPath
        + (deeplinkSearch.length === 0 ? '' : `?${deeplinkSearch}`)
        + (hashString.length === 0 ? '' : `#${hashString}`);
}
